module.exports = __webpack_public_path__ + "static/media/john.2899c700.png";